import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
/**
 * RoleGuard is an Angular route guard that checks whether the user has the required access to the requested route.
 * 
 * The guard checks the value of 'userHasAccess' stored in the localStorage. 
 * The value of 'userHasAccess' is set within the Entra Service when the user logs in and is removed within the AppComponent when the user logs out.
 * 
 * If the value is true, the user is granted access 
 * to the route (i.e., `canActivate` returns true). If the value is false or not found, the user is redirected to the root 
 * page ('/') and route access is prevented (i.e., `canActivate` returns false).
 * 
 * This guard is typically used to protect routes based on user roles or access permissions.
 */
@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Retrieve the value of 'userHasAccess' from localStorage
    const userHasAccess = JSON.parse(localStorage.getItem('userHasAccess') || 'false');

    if (userHasAccess) {
      return true; // User has access
    } else {
      this.router.navigate(['/']); // Redirect to no access page if no access
      return false; // Prevent route access
    }
  }
}
